import React, { Fragment } from 'react';
// import Button from '../../../common/Button';
import PropTypes from 'prop-types';
import './body-text.scss';

const BodyText = ({ data, className }) => {
  let encodedData = '';
  // let renderedButton = null;

  if (data !== null && typeof data === 'object') {
    // standalone BodyText module
    encodedData = data.bodyText ? data.bodyText.replace(/&lt;/g, '<').replace(/&gt;/g, '>') : null;
    className =  data.dropCase ? `${className} drop-case-text` : `${className}`;
    // const { button } = data;
    // renderedButton = <Button button={button} />;
  } else if (typeof data === 'string') {
    // BodyText module that's a child of another module like ImageModule (in which case it's just the rich text editor field)
    encodedData = data.replace(/&lt;/g, '<').replace(/&gt;/g, '>');
  }
  data = encodedData;

  return (
    <Fragment>
      <div className="ipad-wrapper">
        <div className="ipad-btn"></div>
        <div className="outer-container">
          <div className="inner-container">
            <div className={className} dangerouslySetInnerHTML={ { __html: data } } />
          </div>
        </div>
      </div>
    </Fragment>
  );
};

BodyText.propTypes = {
  className: PropTypes.string,
};

export default BodyText;
